__turbopack_context__.v({
  "arrow": "ResearchStudiesSection-module__cR8Axq__arrow",
  "buttonWrap": "ResearchStudiesSection-module__cR8Axq__buttonWrap",
  "empty": "ResearchStudiesSection-module__cR8Axq__empty",
  "filterRow": "ResearchStudiesSection-module__cR8Axq__filterRow",
  "grid": "ResearchStudiesSection-module__cR8Axq__grid",
  "headBlock": "ResearchStudiesSection-module__cR8Axq__headBlock",
  "heading": "ResearchStudiesSection-module__cR8Axq__heading",
  "inner": "ResearchStudiesSection-module__cR8Axq__inner",
  "pageBtn": "ResearchStudiesSection-module__cR8Axq__pageBtn",
  "section": "ResearchStudiesSection-module__cR8Axq__section",
});
